export const S3_IMAGE_URL = "https://etour-image.s3.ap-northeast-2.amazonaws.com/";
export const SERVER_URL = 'https://etour-server.herokuapp.com/';